<template>
  <v-card class="elevation-0" v-if="failures">
    <v-toolbar flat color="white">
      <v-icon color="pink" class="pr-2">sms_failed</v-icon>
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <QueueActionButton
        action="reviveAll"
        color="success"
        label="retry all"
        :resourceType="resourceType"
        :messages="failures"
      />
      <QueueActionButton
        action="killAll"
        color="error"
        label="delete all"
        :resourceType="resourceType"
        :messages="failures"
      />
      <v-btn
        v-if="reload"
        @click="$emit('failedMessages')"
        :disabled="loading"
        class="ma-2"
        small
        outlined
      >
        <v-icon class="pr-2" small>refresh</v-icon>
        Refresh Table
      </v-btn>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="failures"
      :loading="loading"
      item-key="messageId"
    >
      <template v-slot:item.dataSource="{ item }">
        <v-chip color="secondary" small dark>
          {{ item.dataSource }}
        </v-chip>
      </template>

      <template v-slot:item.queuedAt="{ item }">
        <v-chip color="pink" small dark>
          {{ item.queuedAt | date }}
        </v-chip>
      </template>

      <template v-slot:item.reason="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div class="one-line" v-bind="attrs" v-on="on">
              {{ item.reason }}
            </div>
          </template>

          {{ item.reason }}
        </v-tooltip>
      </template>

      <template v-slot:item.deliveryCount="{ item }">
        <v-chip color="secondary" small dark outlined>
          {{ item.deliveryCount }}
        </v-chip>
      </template>

      <template v-slot:item.attempts="{ item }">
        <v-chip color="secondary" small dark outlined>
          {{ item.attempts }}
        </v-chip>
      </template>

      <template v-slot:item.revive="{ item }">
        <v-tooltip color="secondary" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="secondary"
              v-bind="attrs"
              v-on="on"
              :disabled="loading || $store.state.medicating"
              :loading="$store.state.medicating"
              @click.prevent="
                $store.dispatch('revive', {
                  resourceType,
                  messages: [item],
                })
              "
              >replay</v-icon
            >
          </template>
          Retry Run
        </v-tooltip>
      </template>

      <template v-slot:item.kill="{ item }">
        <v-tooltip color="secondary" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              :disabled="loading || $store.state.medicating"
              :loading="$store.state.medicating"
              color="secondary"
              v-bind="attrs"
              v-on="on"
              @click.prevent="
                $store.dispatch('kill', {
                  resourceType,
                  messages: [item],
                })
              "
            >
              delete
            </v-icon>
          </template>
          Forget Run
        </v-tooltip>
      </template>

      <template v-slot:no-data>
        <v-alert color="secondary" dark class="mt-4">{{ noDataLabel }}</v-alert>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import QueueActionButton from '../components/QueueActionButton.vue';

export default {
  components: {
    QueueActionButton,
  },
  props: {
    title: { type: String, default: 'Failed Messages' },
    noDataLabel: {
      type: String,
      default: 'No messages have failed to process',
    },
    failures: { type: Array },
    loading: { type: Boolean },
    resourceType: { type: String },
    customData: {
      type: Array,
      default: () => [],
    },
    reload: { type: Boolean, default: false },
  },
  computed: {
    headers() {
      const displayHeaders = this.customData.map(({ title, width, value }) => ({
        text: title,
        value: value,
        width: width,
        sortable: false,
      }));

      return [
        ...displayHeaders,
        {
          text: 'Queued At',
          sortable: true,
          align: 'left',
          width: '200px',
          value: 'queuedAt',
        },
        {
          text: 'Reason',
          sortable: false,
          align: 'left',
          value: 'reason',
        },
        {
          text: 'Delivery',
          filterable: false,
          sortable: false,
          width: '110px',
          align: 'center',
          value: 'deliveryCount',
        },
        {
          text: 'Attempts',
          filterable: false,
          sortable: false,
          width: '110px',
          align: 'center',
          value: 'attempts',
        },
        {
          text: '',
          value: 'revive',
          width: '50px',
          sortable: false,
          align: 'center',
        },
        {
          text: '',
          value: 'kill',
          width: '50px',
          sortable: false,
          align: 'center',
        },
      ];
    },
  },
};
</script>
